/** Limit on the encrypted .wbackup file, plus room for multipart headers. */
export const maxBackupBytes=110*1024*1024;
export const backupRestoreBodyLimit=maxBackupBytes+1024*1024;
